<template>
  <v-row class="loader-container" no-gutters>
    <v-col xl="8" lg="9" md="11" sm="11" cols="12">
      <v-card class="card-wrapper" elevation="2" tile>
        <flex-view-layout class="flex-layout-container">
          <template v-slot:content>
            <v-skeleton-loader v-for="i in size" type="list-item-two-line" :key="i + '_item'"></v-skeleton-loader>
          </template>
          <template v-slot:footer>
            <div class="actions-content">
              <v-skeleton-loader class="button-loader" type="button"></v-skeleton-loader>
            </div>
          </template>
        </flex-view-layout>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import FlexViewLayout from '@/layouts/FlexViewLayout'

export default {
  name: 'FormLoader',
  components: {
    FlexViewLayout
  },
  props: {
    size: {
      type: Number,
      default: 4
    }
  }
}
</script>
<style scoped>
.loader-container {
  justify-content: center;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.card-wrapper {
  min-height: 38.75rem;
}
.flex-layout-container {
  min-height: inherit;
  padding: 2.125rem 2.75rem;
}
.actions-content {
  display: flex;
  justify-content: center;
}
.button-loader >>> .v-skeleton-loader__button {
  width: 20rem;
}
/* 600px */
@media only screen and (max-width:  37.5rem) {
  .loader-container {
    padding-top: 0;
    padding-bottom: 0;
  }
  .card-wrapper {
    min-height: inherit;
  }
  .flex-layout-container {
    padding: 1.5rem 1.25rem 0.25rem 1.25rem;
  }
}
</style>
